import { IExportColumnModel } from "../../../../../shared/models";

export const EmailLayoutsColumnList: IExportColumnModel[] = [
]